<template>
	<div class="circle-sender-comp-container">
		<div class="circle-sender-comp-wrap">
			<div class="circle-sender-comp-custom">
				<div class="circle-sender-comp-c-title">
					<fieldset>
						<legend>发送账号</legend>
						<div class="circle-sender-comp-c-wrap">
							<div class="circle-sender-comp-c-item" :class="{'circle-sender-comp-c-item-active': customIsSelect(custom,true)}"
							 v-for="custom in customList" @click="selectCustom(custom)">
								<span class="circle-sender-comp-c-name">{{custom.identity !== null ? custom.identity : custom.wx_name}}</span>
								<span class="circle-sender-comp-c-choose"></span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="" v-if="message.type !== undefined">
				<div v-if="senderData.type == 3">
					<div class="circle-sender-comp-list">
						<div class="circle-sender-comp-lable">
							链接内容
						</div>
						<div class="circle-sender-comp-info">
							{{senderData.urlContent}}
						</div>
					</div>
					<div class="circle-sender-comp-list">
						<div class="circle-sender-comp-lable">
							链接地址
						</div>
						<div class="circle-sender-comp-info">
							{{senderData.url}}
						</div>
					</div>
				</div>
				<div class="circle-sender-comp-list" v-if="(senderData.type == 1 || senderData.type == 3) && (senderData.imgUrl !== undefined &&  senderData.imgUrl.length > 0)">
					<div class="circle-sender-comp-lable">
						图片
					</div>
					<div class="circle-sender-comp-info" v-if="senderData.type == 1">
						<img :src="img" alt="" v-for="img in senderData.imgUrl">
					</div>
					<div class="circle-sender-comp-info" v-else>
						<img :src="senderData.imgUrl">
					</div>
				</div>
				<div class="circle-sender-comp-list" v-if="senderData.type == 2">
					<div class="circle-sender-comp-lable">
						视频
					</div>
					<div class="circle-sender-comp-info">
						<video :src="senderData.imgUrl"></video>
					</div>
				</div>
				<div class="circle-sender-comp-list" v-if="senderData.type == 30 || senderData.type == 31">
					<div class="circle-sender-comp-lable">
						视频号
					</div>
					<div class="circle-sender-comp-info">
						<div class="csc-chat-finder">
							<div class="csc-chat-finder-img"> 
								<img :src="orgContentObj.thumbUrl !== undefined ? orgContentObj.thumbUrl : orgContentObj.coverUrl" class="csc-chat-finder-thumb"> 
								<img src="/img/video_play.png" class="csc-chat-finder-play"> 
							</div>
							<div class="csc-chat-finder-info"> 
								<img :src="orgContentObj.avatar !== undefined ? orgContentObj.avatar : orgContentObj.headUrl">
								<p>{{orgContentObj.nickname}}</p>
							</div>
							<div class="csc-chat-finder-desc">
								<p>{{orgContentObj.desc !== undefined ? orgContentObj.desc : orgContentObj.desc1}}</p>
							</div>
							<div class="csc-chat-finder-tip"> <img src="/img/finder.png">
								<p>视频号直播</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="circle-sender-ct-options">
				<div class="circle-sender-comp-optbox" v-show="showEmoji">
					<emoji key="circle-sender-comp-tools-box-emoji" @emoji-call="contentEmojiCall($event)"></emoji>
				</div>
				<span class="circle-sender-cto-emoji" @click="contentEmojiClick" style="margin-left: 10px;margin-bottom: 5px;"></span>
			</div>
			<div class="circle-sender-comp-input">
				<chatting-input :defaultMsg="senderData.type < 30 ? orgContent : ''" 
					@chat-input-msg="chatInputMsg($event)"
					@chat-input-focus="chatInputFocus($event)" 
					ref="circleSenderInput" 
					key="circle-sender-comp-input"
					:chatToolsData="chatToolsData">
				</chatting-input>
			</div>
			<div class="circle-sender-comp-menu">
				<div class="circle-sender-comp-m-wrap">
					<div class="circle-sender-comp-ml">
						<span @click="addComment">添加评论</span>
						<span style="background-color: #FFFFFF;color: #666666;">{{commentList.length}}条评论</span>
					</div>
					<div class="circle-sender-comp-mr" style="line-height: 30px;">
						<span class="circle-sender-comp-mr-count">{{senderData.content.length}}/800</span>
						<span class="circle-sender-comp-mr-send" @click="sendMoment">发表</span>
					</div>
				</div>
			</div>
			<div class="circle-sender-comp-comment">
				<div class="circle-sender-comp-comment-item" v-for="(comment,key) in commentList" :key="'circle-sender-comp-comment-'+key">
					<div class="circle-sender-comp-c-text">
						<textarea name="" id="" v-model="comment.content"></textarea>
					</div>
					<div class="circle-sender-comp-c-tools">
						<div class="circle-sender-comp-ct-time" style="display: none;">
							<label>延时发送</label>
							<input type="text" v-model="comment.delayHour">
							<span>小时</span>
							<input type="text" v-model="comment.delayMinute">
							<span>分钟</span>
							<span class="circle-sender-comp-ctt-c" @click="delayTime(key,3)">3分钟</span>
							<span class="circle-sender-comp-ctt-c" @click="delayTime(key,10)">10分钟</span>
							<span class="circle-sender-comp-ctt-c" @click="delayTime(key,15)">15分钟</span>
							<span class="circle-sender-comp-ctt-c" @click="delayTime(key,30)">30分钟</span>
						</div>
						<div class="circle-sender-comp-ct-options">
							<div class="circle-sender-comp-cto-view" v-show="comment.showEmoji">
								<emoji :key="'circle-sender-comp-comment-emoji-'+key" @emoji-call="commentEmojiCall($event,key)"></emoji>
							</div>
							<span class="circle-sender-comp-cto-emoji" @click="commentEmojiClick(key)"></span>
							<span @click="commentEmojiDel(key)">删除</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ChattingInput from './ChattingInput.vue'
	import {
		pushSendMoment
	} from '../socket/socketEventSender.js'
	import {
		webMomentsSave
	} from '../network/web/moments.js'
	import {
		getCustomList
	} from '../network/local/custom.js'
	import Emoji from '../components/Emoji.vue'

	export default {
		name: 'CircleSenderComp',
		props: {
			message: {
				type: Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				showEmoji: false,
				customList: [],
				commentList: [],
				chatToolsData: {},
				inputFocus: 0,
				selectCustomList: [],
				circleTemp: {},
				orgContent: '',
				orgContentObj: {},
				senderData: {
					id: 0,
					type: 1,
					content: '',
					imgUrl: [],
					cover: '',
					urlContent: '',
					url: '',
				}
			}
		},
		components: {
			ChattingInput,
			Emoji
		},
		methods: {
			// 数据初始化
			initData() {
				this.circleTemp = {}
				this.commentList = []
				this.orgContent = ''
				this.orgContentObj = {}
				this.senderData = {
					id: 0,
					type: 1,
					content: '',
					imgUrl: [],
					cover: '',
					urlContent: '',
					url: '',
				}
			},

			// 客服点击
			selectCustom(custom) {
				let selectData = this.customIsSelect(custom)
				if (selectData.isSelect) {
					this.selectCustomList.splice(selectData.index, 1)
				} else {
					this.selectCustomList.push({
						id: custom.id,
						open_id: custom.open_id,
						phone_id: custom.phone_id
					})
				}
			},

			// 判断客服是否选中
			customIsSelect(custom, backBoolean) {
				let isSelect = false
				let index = 0
				for (let i = 0; i < this.selectCustomList.length; i++) {
					if (this.selectCustomList[i].id === custom.id) {
						isSelect = true
						index = i
						break
					}
				}
				if (backBoolean) {
					return isSelect
				}
				return {
					isSelect: isSelect,
					index: index
				}
			},
			
			// 表情点击
			contentEmojiClick(){
				this.showEmoji = !this.showEmoji
			},
			
			// 回调-工具栏表情点击回调
			contentEmojiCall(emoji) {
				this.chatToolsData = {
					type: 'emoji',
					data: emoji
				}
			},
			

			// 添加评论
			addComment() {
				this.commentList.push({
					content: '',
					showEmoji: false,
					delayMinute: 0,
					delayHour: 0
				})
			},

			// 评论中emoji点击
			commentEmojiClick(index) {
				for (let i = 0; i < this.commentList.length; i++) {
					if (i === index) {
						this.commentList[i].showEmoji = !this.commentList[i].showEmoji
					} else {
						this.commentList[i].showEmoji = false
					}
				}
			},

			// 评论删除
			commentEmojiDel(index) {
				this.commentList.splice(index, 1)
			},

			// 延时时间点击
			delayTime(index, time) {
				this.commentList[index].delayMinute = time
			},

			// 发表朋友圈
			sendMoment() {
				if (this.senderData.type == 1) {
					if (this.senderData.content === '' && this.senderData.imgUrl.length === 0) {
						CHAT_LAYER.msg('发圈内容为空', {
							icon: 2
						})
						return
					}
				} else if (this.senderData.type == 2) {
					if (this.senderData.imgUrl.length === 0) {
						CHAT_LAYER.msg('视频内容为空', {
							icon: 2
						})
						return
					}
				} else if (this.senderData.type == 3) {
					if (this.senderData.imgUrl.length === 0 || this.senderData.url === '' || this.senderData.urlContent === '') {
						CHAT_LAYER.msg('链接内容为空', {
							icon: 2
						})
						return
					}
				}
				if (this.selectCustomList.length === 0) {
					CHAT_LAYER.msg('请选择客服', {
						icon: 2
					})
					return
				}
				// 去除引用，避免监听的属性变化，引起数据错乱
				let momentsData = JSON.parse(JSON.stringify(this.senderData))
				// 只有选择一个粉丝的情况下，才触发@和给谁看
				if (this.selectCustomList.length === 1) {
					momentsData.auth = this.authFans
					momentsData.remindFans = this.remindFans
				}
				// 拼接评论
				let comment = []
				if (this.commentList.length > 0) {
					for (let i = 0; i < this.commentList.length; i++) {
						comment.push(this.commentList[i].content)
					}
				}
				momentsData.comment = comment
				momentsData.content = momentsData.content.replace(/<br\/>/g, '<br>')
				// 如果是视频号或者是视频直播消息，则重新拼接content
				if (momentsData.type == 30 || momentsData.type == 31) {
					let extraContent = JSON.parse(this.orgContent)
					extraContent.extraDesc = momentsData.content
					if(extraContent.username === undefined && extraContent.finderUsername !== undefined){
						extraContent.username = extraContent.finderUsername
					}else if(extraContent.finderUsername === undefined && extraContent.username !== undefined){
						extraContent.finderUsername = extraContent.username
					}
					momentsData.content = JSON.stringify(extraContent)
				}
				// 循环推送
				for (let i = 0; i < this.selectCustomList.length; i++) {
					webMomentsSave(momentsData, this.selectCustomList[i].id, this.selectCustomList[i].open_id, data => {
						if (data > 0) {
							pushSendMoment(momentsData, this.selectCustomList[i].open_id, this.selectCustomList[i].phone_id, data)
						}
					})
				}
				this.initData()
				CHAT_LAYER.msg('指令已推送，请稍后查看发送结果。', {
					icon: 1
				})
				this.$emit('circle-sender-close')
			},

			// 回调-输入框输入回调
			chatInputMsg(val) {
				// 只取数值第一个元素信息
				for (let i = 0; i < val.length; i++) {
					if (val[i].type == 'text') {
						this.senderData.content = val[i].content
						break
					}
				}
			},

			// 回调-聚焦回调
			chatInputFocus(val) {
				this.inputFocus = val
				this.showEmoji = false
			},

			// 评论模块的表情点击回调
			commentEmojiCall(data, index) {
				this.commentList[index].content += '[' + data.title + ']'
				this.commentList[index].showEmoji = false
			},

			// 处理传进来的数据
			handleMsg() {
				if (this.message.type === undefined) {
					return
				}
				let msgType = this.message.type
				let allowType = ['text', 'image', 'video', 'link', 'finder', 'finder_live']
				if (allowType.indexOf(msgType) === -1) {
					return
				}
				let type = 0
				let imgUrl = ''
				let cover = ''
				let url_content = ''
				let url = ''
				let content = ''
				switch (msgType) {
					case 'text':
						type = 1
						content = this.message.content
						this.orgContent = content
						break
					case 'image':
						type = 1
						imgUrl = this.message.content
						break
					case 'video':
						type = 2
						imgUrl = this.message.content
						cover = ''
						break
					case 'link':
						let linkObj = JSON.parse(this.message.content)
						type = 3
						imgUrl = linkObj.link_img
						url_content = linkObj.link_desc
						url = linkObj.link_url
						break
					case 'finder':
						type = 30
						this.orgContent = this.message.content
						this.orgContentObj = JSON.parse(this.orgContent)
						break
					case 'finder_live':
						type = 31
						this.orgContent = this.message.content
						this.orgContentObj = JSON.parse(this.orgContent)
						break
				}
				this.senderData.type = type
				if (imgUrl !== '') {
					if (type === 1) {
						this.senderData.imgUrl.push(imgUrl)
					} else {
						this.senderData.imgUrl = imgUrl
					}
				}
				this.senderData.cover = cover
				this.senderData.urlContent = url_content
				this.senderData.url = url
				this.senderData.content = content
			}
		},
		computed: {
		},
		created() {
			getCustomList(res => {
				this.customList = res
				this.handleMsg()
			})
		}
	}
</script>

<style>
	.circle-sender-comp-container {
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		color: #888888;
	}

	.circle-sender-comp-container .circle-sender-comp-wrap {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.circle-sender-comp-wrap .circle-sender-comp-custom {
		padding: 10px;
		width: 100%;
		box-sizing: border-box;
	}

	.circle-sender-comp-custom .circle-sender-comp-c-title {
		width: 100%;
		font-size: 16px;
	}

	.circle-sender-comp-c-title fieldset {
		border: 1px solid #e3e3e3;
	}

	.circle-sender-comp-c-title fieldset legend {
		margin-left: 20px;
		padding: 0 10px;
	}

	.circle-sender-comp-custom .circle-sender-comp-c-wrap {
		min-height: 40px;
		max-height: 120px;
		overflow-x: hidden;
		overflow-y: auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	.circle-sender-comp-c-wrap .circle-sender-comp-c-item {
		height: 28px;
		min-width: 60px;
		border: 1px solid #e2e2e2;
		margin: 5px;
		border-radius: 2px;
		cursor: pointer;
		color: #666666;
	}

	.circle-sender-comp-c-wrap .circle-sender-comp-c-item-active {
		border: 1px solid #42B983 !important;
	}

	.circle-sender-comp-c-item span {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		vertical-align: middle;
	}

	.circle-sender-comp-c-item .circle-sender-comp-c-name {
		padding: 0 5px;
		background-color: #e2e2e2;
	}

	.circle-sender-comp-c-item .circle-sender-comp-c-choose {
		width: 28px;
		height: 28px;
		background-position: center;
		background-size: 22px 22px;
		background-repeat: no-repeat;
		background-image: url(../assets/img/correct-48.png);
	}

	.circle-sender-comp-c-item-active>.circle-sender-comp-c-name {
		background-color: #42B983;
		color: #ffffff;
	}

	.circle-sender-comp-c-item-active>.circle-sender-comp-c-choose {
		background-image: url(../assets/img/correct-48-active.png);
	}

	.circle-sender-comp-wrap .circle-sender-comp-template {
		width: 100%;
		height: 46px;
		line-height: 46px;
		border-bottom: 1px solid #e3e3e3;
		overflow: hidden;
	}

	.circle-sender-comp-template .circle-sender-comp-t-wrap {
		padding: 0 10px;
		height: 46px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		overflow: hidden;
	}

	.circle-sender-comp-t-wrap .circle-sender-comp-t-show {
		height: 46px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.circle-sender-comp-t-show .circle-sender-comp-ts-icon {
		width: 20px;
		height: 20px;
		margin-right: 10px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url(../assets/img/template-bf-32.png);
	}

	.circle-sender-comp-t-show .circle-sender-comp-ts-auth-icon {
		background-image: url(../assets/img/friend-bf-32.png) !important;
	}

	.circle-sender-comp-t-show .circle-sender-comp-ts-aite-icon {
		background-image: url(../assets/img/aite-bf-32.png) !important;
		background-size: 18px auto;
	}

	.circle-sender-comp-t-wrap .circle-sender-comp-t-choose {
		height: 46px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		cursor: pointer;
	}

	.circle-sender-comp-t-choose .circle-sender-comp-tc-icon {
		width: 22px;
		height: 22px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		background-image: url(../assets/img/show-bf-32.png);
	}

	.circle-sender-comp-wrap .circle-sender-comp-tools-box {
		width: 100%;
	}

	.circle-sender-comp-wrap .circle-sender-comp-input {
		width: 100%;
		height: 120px;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;
		padding-top: 0;
	}

	.circle-sender-comp-input .circle-sender-comp-i-wrap {
		width: 100%;
		height: 100%;
		border: 1px solid #e3e3e3;
		border-radius: 4px;
		padding: 10px;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
		outline: none;
	}

	.circle-sender-comp-i-wrap:focus {
		border: 1px solid #42B983;
	}

	.circle-sender-comp-i-wrap img {
		max-width: 100%;
	}

	.circle-sender-comp-wrap .circle-sender-comp-menu {
		padding: 10px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}

	.circle-sender-comp-menu .circle-sender-comp-m-wrap {
		height: 30px;
		overflow: hidden;
		display: flex;
		justify-content: flex-end;
	}

	.circle-sender-comp-m-wrap .circle-sender-comp-ml,
	.circle-sender-comp-m-wrap .circle-sender-comp-mr {
		height: 30px;
		overflow: hidden;
	}

	.circle-sender-comp-ml span,
	.circle-sender-comp-mr span {
		height: 30px;
		padding: 0 10px;
		display: inline-block;
		vertical-align: middle;
		background-color: #009688;
		color: #e7e7e7;
		border-radius: 2px;
		cursor: pointer;
		margin: 0 5px;
	}

	.circle-sender-comp-mr .circle-sender-comp-mr-send {
		background-color: #1178b5;
		user-select: none;
	}

	.circle-sender-comp-mr .circle-sender-comp-mr-count {
		background-color: #FFFFFF;
		color: #666666;
	}

	.circle-sender-comp-wrap .circle-sender-comp-comment {
		padding: 0 10px;
		user-select: none;
	}

	.circle-sender-comp-comment-item {
		padding: 5px 0;
	}

	.circle-sender-comp-comment .circle-sender-comp-c-text {
		width: 100%;
	}

	.circle-sender-comp-c-text textarea {
		width: 100%;
		height: 60px;
		border: 1px solid #e3e3e3;
		padding: 5px;
		box-sizing: border-box;
		line-height: 16px;
		resize: none;
		border-radius: 4px;
		color: #888888;
	}

	.circle-sender-comp-comment .circle-sender-comp-c-tools {
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: space-between;
	}

	.circle-sender-comp-ct-time>* {
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}

	.circle-sender-comp-ct-time>input {
		border: 1px solid #CCCCCC;
		width: 20px;
		height: 20px;
		padding: 0 5px;
		color: #666666;
	}

	.circle-sender-comp-ct-time .circle-sender-comp-ctt-c {
		background-color: #009688;
		color: #FFFFFF;
		height: 18px;
		line-height: 18px;
		padding: 2px 8px;
		cursor: pointer;
	}

	.circle-sender-comp-ct-options {
		position: relative;
		width: 100%;
	}

	.circle-sender-comp-ct-options .circle-sender-comp-cto-view {
		position: absolute;
		width: 405px;
		height: 200px;
		bottom: 40px;
		left: 0;
	}

	.circle-sender-comp-cto-view .comp-emoji-container::after {
		left: 5px !important;
	}

	.circle-sender-comp-ct-options>span {
		display: inline-block;
		vertical-align: middle;
		background-color: #ff5500;
		color: #FFFFFF;
		height: 18px;
		line-height: 18px;
		padding: 2px 8px;
		cursor: pointer;
	}

	.circle-sender-comp-ct-options .circle-sender-comp-cto-emoji {
		width: 22px;
		height: 22px;
		padding: 0;
		background-color: #FFFFFF;
		background-image: url(../assets/img/comp-c-tools-emoji.png);
		background-position: center;
		background-size: cover;
		margin-right: 10px;
	}

	.circle-sender-comp-list {
		padding: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border-top: 1px solid #e3e3e3;
	}

	.circle-sender-comp-list .circle-sender-comp-lable {
		width: 70px;
	}

	.circle-sender-comp-list .circle-sender-comp-info {
		flex: 1;
	}

	.circle-sender-comp-info>img {
		width: 100px;
		height: 100px;
		border-radius: 4px;
		border: 1px solid #e3e3e3;
	}

	.circle-sender-comp-info video {
		max-width: 600px;
		max-height: 400px;
	}
	.csc-chat-finder{
		width: 220px;
		height: auto;
		cursor: pointer;
		background-color: #FFFFFF;
		border: 1px solid #e3e3e3;
	}
	.csc-chat-finder-img{
		width: 100%;
		height: auto;
		position: relative;
	}
	.csc-chat-finder-img > .csc-chat-finder-thumb{
		width: 100%;
		height: auto;
	}
	.csc-chat-finder-img .csc-chat-finder-play{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 40px;
		height: 40px;
	}
	.csc-chat-finder-info{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 14px;
	}
	.csc-chat-finder-info > img{
		width: 22px;
		height: 22px;
		display: block;
		margin: 0 5px;
		border-radius: 11px;
	}
	.csc-chat-finder-desc{
		padding: 0 5px;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
	}
	.csc-chat-finder-desc p{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.csc-chat-finder-tip{
		border-top: 1px solid #EEEEEE;
		margin-top: 5px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.csc-chat-finder-tip > img{
		width: 18px;
		height: 18px;
		display: block;
		margin: 0 5px;
	}
	.circle-sender-comp-optbox{
		position: absolute;
		width: 405px;
		height: 200px;
		bottom: 40px;
		left: 5px;
	}
</style>
